// extracted by mini-css-extract-plugin
export var btn = "ButtonWithIcon-module--btn--4757f";
export var sm = "ButtonWithIcon-module--sm--f7458";
export var xs = "ButtonWithIcon-module--xs--aac1c";